import {
  differenceInDays,
  differenceInSeconds,
  isValid,
  parse,
} from "date-fns";
import { useEffect, useMemo, useState } from "react";

export const useTimeCounter = (dateTime) => {
  const date = useMemo(() => {
    return parse(dateTime, "dd/MM/yyyy HH:mm:ss", new Date());
  }, [dateTime]);
  // const [time, setTime] = useState(0);
  const time = useMemo(() => {
    if (!isValid(date)) return 0;
    return differenceInSeconds(new Date(), date);
  }, [date]);
  // const [days, setDays] = useState(0);
  const days = useMemo(() => {
    if (!isValid(date)) return 0;
    return differenceInDays(new Date(), date);
  }, [date]);

  return { time, days };
};
